// extracted by mini-css-extract-plugin
export default {"aboutUsWrapper":"_AboutUs_aboutUsWrapper__mpjMi","aboutUsLabel":"_AboutUs_aboutUsLabel__LwVX4","leadersLabel":"_AboutUs_leadersLabel__Im-O6"};